import React from 'react';
import PageTemplate from '../../components/template/PageTemplate/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponIssueHistoryDetailWrap } from '../../views/coupon-v2/issueHistory/CouponIssueHistoryDetailWrap';

/**
 *  쿠폰 발급 내역 상세 페이지
 */
const CouponIssueHistoryDetail = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_ISSUE_HISTORY_DETAIL}>
      <CouponIssueHistoryDetailWrap />
    </PageTemplate>
  );
};

export default CouponIssueHistoryDetail;
